import AddLinkOutlinedIcon from '@mui/icons-material/AddLinkOutlined';
import { Button } from '@mui/material';
import type { ButtonProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Notification } from '@/shared/ui';

import { useConnectAmoCrmIntegration } from '../model/useConnectAmoCrmIntegration';

type ConnectAmoCrmButtonProps = Omit<ButtonProps, 'onClick'>;

export const ConnectAmoCrmButton = ({
  disabled,
  variant = 'contained',
  ...props
}: ConnectAmoCrmButtonProps) => {
  const { t } = useTranslation();
  const connectMutation = useConnectAmoCrmIntegration();

  return (
    <>
      <Button
        variant={variant}
        startIcon={<AddLinkOutlinedIcon />}
        disabled={disabled || connectMutation.isPending}
        onClick={() => connectMutation.mutate()}
        {...props}
      >
        {connectMutation.isPending
          ? t('integrations:oauth.connecting')
          : t('integrations:oauth.connectAmocrm')}
      </Button>
      <Notification
        open={connectMutation.isError}
        title={connectMutation.error?.message}
      />
    </>
  );
};
